import {DecimalPipe, JsonPipe, NgFor, NgIf, NgOptimizedImage, TitleCasePipe} from '@angular/common';
import {
  Component, EventEmitter, Input, OnInit, Output
} from '@angular/core';
import { Agency, Agent } from 'src/app/api';
import { AppComponent } from 'src/app/app.component';
import { LazyLoadImagesDirective } from '../../../directives/lazy-load-images.directive';
import { BadgeComponent } from '../badge/badge.component';

@Component({
  selector: 'app-card-agente',
  templateUrl: './card-agente.component.html',
  styleUrls: ['./card-agente.component.scss'],
  standalone: true,
  imports: [LazyLoadImagesDirective, NgIf, BadgeComponent, NgFor, DecimalPipe, TitleCasePipe, JsonPipe, NgOptimizedImage]
})
export class CardAgenteComponent implements OnInit {
  imgLogoError = false;

  @Input() agentObj: Agent;
  @Input() agencyObj: Agency;
  @Input() isDetailAgencyPage: boolean;
  @Output() openPopup = new EventEmitter();

  constructor(public main: AppComponent) { }

  ngOnInit(): void {
  }

  generateUrl(): string {
    return `/dettaglio-agente/${this.agentObj?.slug}`;
  }

  countForSale(): number {
    return this.agentObj.listings.filter(a => a.contract_type === 'buy' && a.status === 'available').length;
  }
  countOnRent(): number {
    return this.agentObj.listings.filter(a => a.contract_type === 'rent' && a.status === 'available').length;
  }
  countSold(): number {
    return this.agentObj.listings?.filter(a => a.contract_type === 'buy' && a.status === 'sold').length;
  }
  countRented(): number {
    return this.agentObj.listings?.filter(a => a.contract_type === 'rent' && a.status === 'rented').length;
  }

  countAgentSkills(): number | boolean {
    let result = false;
    Object.values(this.agentObj?.agent_skill_percentage).forEach(value => {
      if (value > 0) {
        result = true;
      }
    });
    return result;
  }

  orderAgentSkills(): {} {
    const skills = [];
    let numberOfHiddens = 0;
    for (const [key, value] of Object.entries(this.agentObj?.agent_skill_percentage)) {
      if (value > 0) {
        skills.push(
          {
            name: key.replace('_', ' '),
            value
          }
        );
      }
    }

    const stringsSkills = [];
    if (skills.length > 3) {
      numberOfHiddens = skills.length - 3;
    }
    skills.sort((a, b) => a - b).slice(0, 3).forEach(obj => {
      stringsSkills.push(`${this.main.toTitleCase(obj.name)}: ${obj.value}%`);
    });

    return { skills: stringsSkills, numberOfHiddens };
  }

  async handleFavouriteAgent(): Promise<number | void> {
    if (this.main?.isLogged) {
      const result = await this.main?.savedAgentListing(this.agentObj);
      this.agentObj.numberOfFavourites += result;
    } else {
      this.openPopup.emit();
    }
  }

  // GESTIONE LIKE
  async handleLikesagent(): Promise<number | void> {
    if (this.main?.isLogged) {
      const result = await this.main?.likedAgentEvt(this.agentObj);
      this.agentObj.likes += result;
    } else {
      this.openPopup.emit();
    }
  }
}
